var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dot-slider"
  }, [_c('div', {
    staticClass: "dot-slider__wrapper"
  }, [_c('div', {
    staticClass: "dot-slider__sliding-block",
    style: {
      transform: _vm.currentTransform
    }
  }, _vm._l(_vm.count, function (el, index) {
    return _c('div', {
      key: el,
      staticClass: "dot-slider__dot",
      class: {
        'dot-slider__dot_active': index === _vm.current,
        'dot-slider__dot_small': _vm.isSmall(index)
      }
    });
  }), 0)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }